// AWS本番環境設定
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Auth: {
    region: "ap-northeast-1",
    userPoolId: "ap-northeast-1_iKpGxRjjD",
    userPoolWebClientId: "3in2qmv29cv5jedhgijgph9b8q",
    identityPoolId: "ap-northeast-1:d4f9fd9d-8888-4ba6-b819-7b2cfdaa3cc2"
  },
  API: {
    endpoints : [
      {
        name: "aia-api-prd",
        endpoint: "https://l9bu56uvsa.execute-api.ap-northeast-1.amazonaws.com/v1",
        region: "ap-northeast-1"
      }
    ]
  }
}
